import { Routes, Route, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import { AnimatePresence } from 'framer-motion';
import NavigationShell from './components/NavigationShell';
import ChatBot from './components/ChatBot';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import BITools from './pages/BITools';
import IntegrationTools from './pages/IntegrationTools';
import ConsultingServices from './pages/ConsultingServices';
import TrainingSupport from './pages/TrainingSupport';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import LiveDashboard from './pages/LiveDashboard';

/**
 * App - Main application component with smooth page transitions
 */
function App() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col">
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
        <ScrollToTop />
        <NavigationShell>
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/bi-tools" element={<BITools />} />
              <Route path="/integration-tools" element={<IntegrationTools />} />
              <Route path="/consulting-services" element={<ConsultingServices />} />
              <Route path="/training-support" element={<TrainingSupport />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/live-dashboard" element={<LiveDashboard />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<div className="container mx-auto px-4 py-12 text-center"><h1 className="text-4xl font-bold">404 - Page Not Found</h1></div>} />
            </Routes>
          </AnimatePresence>
        </NavigationShell>
        {/* Floating AI ChatBot - persists across all pages */}
        <ChatBot />
      </Suspense>
    </div>
  );
}

export default App;
